/**
 * Canadian French resource bundle — MVP support (PRD §2.5 BR-I18N-01).
 * Quebec / Acadian register. NOT European French formality.
 * Real French quotation marks « … » with non-breaking spaces.
 */
export const frCA = {
  common: {
    cancel: 'Annuler',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    loading: 'Chargement…',
    skip: 'Passer',
    confirm: 'Confirmer',
    retry: 'Réessayer',
  },
  auth: {
    signIn: 'Se connecter',
    signUp: 'Créer votre compte',
    signOut: 'Se déconnecter',
    emailLabel: 'Courriel',
    passwordLabel: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié\u00a0?',
    noAccount: 'Nouveau sur InkFinity\u00a0?',
    haveAccount: 'Vous avez déjà un compte\u00a0?',
    createAccount: 'Créer un compte',
    continueWithGoogle: 'Continuer avec Google',
    continueWithGitHub: 'Continuer avec GitHub',
    orSignUpWithEmail: 'ou inscrivez-vous par courriel',
    agreeTermsPrefix: 'J\u2019accepte les',
    termsOfService: 'Conditions d\u2019utilisation',
    and: 'et la',
    privacyPolicy: 'Politique de confidentialité',
    passwordHint: 'Au moins 8 caractères, avec majuscule, minuscule et chiffre.',
    invalidEmail: 'Veuillez entrer une adresse courriel valide.',
    weakPassword: 'Le mot de passe doit inclure une majuscule et un chiffre.',
    termsRequired: 'Vous devez accepter les conditions.',
  },
  chat: {
    newChat: 'Nouvelle conversation',
    sendPlaceholder: 'Écrivez une invite, collez un fichier ou choisissez une idée…',
    replyPlaceholder: 'Répondre ou joindre un fichier…',
    emptyHeadline: 'Par où voulez-vous commencer\u00a0?',
    emptyBody: 'Démarrez une conversation. On s\u2019occupe du reste ensemble.',
    modeAgent: 'Agent',
    modePlan: 'Plan',
    modeAsk: 'Lecture',
    streaming: 'Génération…',
    pause: 'Mettre en pause',
    resume: 'Reprendre',
    readOnlyBadge: 'Lecture seule',
    planReady: 'Plan prêt pour révision',
    approvePlan: 'Approuver et exécuter',
    editPlan: 'Modifier le plan',
  },
  files: {
    dropzoneTitle: 'Déposez vos fichiers ici',
    dropzoneSub:
      '…ou cliquez pour parcourir. L\u2019IA lira et citera tout ce que vous téléversez.',
    chooseFiles: 'Choisir des fichiers',
    uploadLimit: 'Jusqu\u2019à {size} par fichier · {count} fichiers à la fois · {total} au total',
    uploadSuccess: '{count} fichiers téléversés',
  },
  errors: {
    generic: 'Une erreur s\u2019est produite. Veuillez réessayer.',
    network: 'Erreur réseau. Vérifiez votre connexion.',
    rateLimited: 'Trop de requêtes. Veuillez patienter.',
    fileTooLarge: 'Fichier trop volumineux — dépasse la limite de {limit}',
    unsupportedFormat: 'Format non pris en charge',
    virusDetected: 'Bloqué par l\u2019analyse antivirus',
  },
  settings: {
    profile: 'Profil',
    password: 'Mot de passe',
    language: 'Langue',
    memory: 'Mémoire',
    plan: 'Forfait et facturation',
    dataExport: 'Exporter vos données',
    deleteAccount: 'Supprimer le compte',
    deleteConfirmPhrase: 'supprimer mon compte',
  },
  a11y: {
    skipToMain: 'Passer au contenu principal',
    closeMenu: 'Fermer le menu',
    openMenu: 'Ouvrir le menu',
    loadingAnnouncement: 'Chargement, veuillez patienter',
    errorAnnouncement: 'Erreur\u00a0: {message}',
  },
} as const;

export type FrCAMessages = typeof frCA;
